module.exports = __webpack_public_path__ + "static/media/la-nuit-etoilee.cb4ce0f3.png";